import { DragOutlined, FileOutlined } from '@ant-design/icons'
import { Localizable } from '@components/localizable/Localizable'
import { Menu as MenuModel } from '@models/Menu'
import { useAppSelector } from '@store/hooks'
import { selectMenuById } from '@store/MenuReducer'
import { SBModelComponent } from '@supplement-bacon/react-toolkit/models'
import { Space, Tag, Tooltip, Typography } from 'antd'
import { AvatarProps } from 'antd/es/avatar'
import { FC } from 'react'
import { Link } from 'react-router-dom'

const { Text } = Typography

type Props = SBModelComponent<MenuModel> & {
  size?: AvatarProps['size']
  type?: 'full' | 'condensed'
}

const MenuAvatar: FC<Props> = ({
  id,
  model,
  size = 'default',
  type = 'full',
}) => {
  const item = model ? model : useAppSelector(selectMenuById(id!))

  if (!item) {
    return <></>
  }

  return (
    <Space orientation="horizontal">
      <Text style={{ fontSize: 18 }}>
        <DragOutlined />
      </Text>
      <Localizable.Render
        item={item}
        render={(localizedItem, lang) => (
          <Text>
            {lang.flag} {localizedItem.label}{' '}
            <Tooltip title={'Open file'}>
              <Link to={localizedItem.url} target="_blank">
                <Tag>
                  <FileOutlined />
                </Tag>
              </Link>
            </Tooltip>
          </Text>
        )}
      />
    </Space>
  )
}

type MenuAvatarType = { Avatar: typeof MenuAvatar }

export { MenuAvatar, type MenuAvatarType }
